/* tslint:disable */

/**
 */
export class CalculationParameter {
    STUDY_ALPHA_BOTTOM?: number;
    ERROR_H?: number;
    HORIZ_SCAN?: boolean;
    ID_CALC_PARAMS?: number;
    ID_STUDY_EQUIPMENTS?: number;
    MAX_IT_NB?: number;
    NB_OPTIM?: number;
    PRECISION_LOG_STEP?: number;
    PRECISION_REQUEST?: number;
    RELAX_COEFF?: number;
    STOP_AVG?: number;
    STOP_BOTTOM_SURF?: number;
    STOP_INT?: number;
    STOP_TOP_SURF?: number;
    STORAGE_STEP?: number;
    ERROR_T?: number;
    STUDY_ALPHA_BOTTOM_FIXED?: boolean;
    STUDY_ALPHA_FRONT?: number;
    STUDY_ALPHA_FRONT_FIXED?: boolean;
    STUDY_ALPHA_LEFT?: number;
    STUDY_ALPHA_LEFT_FIXED?: boolean;
    STUDY_ALPHA_REAR?: number;
    STUDY_ALPHA_REAR_FIXED?: boolean;
    STUDY_ALPHA_RIGHT?: number;
    STUDY_ALPHA_RIGHT_FIXED?: boolean;
    STUDY_ALPHA_TOP?: number;
    STUDY_ALPHA_TOP_FIXED?: boolean;
    TIME_STEP?: number;
    TIME_STEPS_NB?: number;
    VERT_SCAN?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/calculation-parameter.ts